import { Controller } from "@hotwired/stimulus"

// A row of the rounds list opens its round (#8739).
//
// Only the id was clickable: a row 1500px wide with one live word in its left
// corner, while the coordinator reads the WHOLE line — the drivers, the
// closure, the counters — and then has to aim at the number.
//
// Everything but the Action column, which is where a round is CLOSED. A click
// meant to file a round away must not navigate instead, and the confirmation
// it raises must not land on another page.
const IGNORED = [
  "a", "button", "form", "input", "select", "textarea", "label",
  "[data-round-row-ignore]"
].join(", ")

export default class extends Controller {
  static values = { url: String }

  // `window.location` rather than an `<a>` around the row: the row carries the
  // closure form, and a link may not contain one. Turbo Drive is off app-wide,
  // so this is how the rest of the page navigates too.
  open(event) {
    if (event.target.closest(IGNORED)) return
    // Selecting a file number to copy it is reading, not clicking.
    if (window.getSelection()?.toString()) return

    window.location.href = this.urlValue
  }
}
